import { WarningIcon } from "@phosphor-icons/react/dist/ssr/Warning";
import * as React from "react";

import { useTheme } from "@up/data";
import { Spinner, Toast, ToastTitle } from "@up/ui";

import { CompleteErrorMessage } from "./complete-error-message";

export const Bottom = function ({
  completeErrors,
  CompleteErrorMessageOverride,
  currentPage,
  disableButtons = false,
  errors,
  isSaving = false,
  navigateToPage,
  navigateToPreviousPage,
  onLastPage = false,
  saveError,
}: {
  completeErrors?: Array<{ message: string }>;
  CompleteErrorMessageOverride?: React.ComponentType<
    React.ComponentProps<typeof CompleteErrorMessage>
  >;
  currentPage: number;
  disableButtons?: boolean;
  errors: Record<string, string>;
  isSaving?: boolean;
  navigateToPage: (page: number) => void;
  navigateToPreviousPage: () => void;
  onLastPage?: boolean;
  saveError?: boolean;
}) {
  const theme = useTheme();

  return (
    <div className="up-form-actions">
      {saveError ? (
        <div className="mb-6">
          <Toast variant="error">
            <ToastTitle inline variant="error">
              We could not save your progress.
            </ToastTitle>
            Please try again or contact support at{" "}
            <a className="underline" href={`mailto:${theme.supportEmail}`}>
              {theme.supportEmail}
            </a>
          </Toast>
        </div>
      ) : null}

      {Object.keys(errors).length ? (
        <div role="alert" className="kup-error-message mb-2 flex items-center">
          <div className="mr-2">
            <WarningIcon aria-hidden={true} size={24} weight="fill" />
          </div>
          Please address all errors before continuing
        </div>
      ) : null}

      {completeErrors && completeErrors.length ? (
        <div className="mb-4">
          <div className="kup-error-message mb-3 flex items-center">
            <div className="mr-2">
              <WarningIcon size={24} weight="fill" />
            </div>
            <div>Please address all errors before submitting</div>
          </div>
          <div>
            {completeErrors.map((err, index) => {
              if (CompleteErrorMessageOverride) {
                return (
                  <CompleteErrorMessageOverride
                    key={index}
                    message={err.message}
                    navigate={navigateToPage}
                  />
                );
              }
              return (
                <CompleteErrorMessage
                  key={index}
                  message={err.message}
                  navigate={navigateToPage}
                />
              );
            })}
          </div>
        </div>
      ) : null}

      <div className="sticky bottom-0 flex flex-wrap items-center pt-4 gap-4 bg-white/80">
        {!onLastPage && (
          <button
            className={`${theme.buttonPrimaryClass} order-2 ${
              isSaving ? "cursor-wait opacity-75" : ""
            } ${disableButtons ? "cursor-not-allowed opacity-75" : ""}`}
            disabled={disableButtons}
            type="submit"
          >
            Next Page
          </button>
        )}

        {onLastPage && (
          <button
            className={`${theme.buttonPrimaryClass} order-2 ${
              isSaving ? "cursor-wait opacity-75" : ""
            } ${disableButtons ? "cursor-not-allowed opacity-75" : ""}`}
            disabled={disableButtons}
            type="submit"
          >
            Submit Application
          </button>
        )}

        {currentPage !== 1 && (
          <button
            className={`${theme.buttonSecondaryClass} order-1 ${
              isSaving ? "cursor-wait opacity-75" : ""
            } ${disableButtons ? "cursor-not-allowed opacity-75" : ""}`}
            disabled={disableButtons}
            onClick={(e) => {
              e.preventDefault();
              navigateToPreviousPage();
            }}
          >
            Previous
          </button>
        )}

        {isSaving && <Spinner className="order-3" />}
      </div>
    </div>
  );
};
